// Phone verification gate (booking forms + account settings)
export const VERIFIED_PHONE_KEY = "verified_phone";
export const VERIFIED_PHONE_OWNER_KEY = "verified_phone_owner";
export const VERIFIED_PHONE_AT_KEY = "verified_phone_at";
